module.exports = __webpack_public_path__ + "static/media/HealthyHipGroup.e0013d6f.png";